import { SVGProps } from 'react';

const SvgArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 9 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      stroke="#202733"
      strokeWidth={1.5}
      strokeLinecap="round"
      d="M4.75 1.5V13M5 12.689 7.939 9.75M4.5 12.69 1.56 9.75"
    />
  </svg>
);

export default SvgArrowDown;
